import { FabricImage } from 'fabric';

export class BadgeImage extends FabricImage {
    constructor(...parameters) {
        super(...parameters);

        this.isImage = true;
        this.id = 'placeholder';
    }
}
